export default __webpack_public_path__ + "static/media/clio-gallery-11.9ddccf0f.jpg";